import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import SignInPage from './pages/signin/SignInPage';
import SignUpPage from './pages/signup/SignUpPage';
import NotesPage from './pages/notes/NotesPage';
import CreateNotePage from './pages/create-note/CreateNotePage';
import PaymentPage from './pages/payment/PaymentPage';
import UpdateNotePage from './pages/update-note/UpdateNotePage';
import AccountPage from './pages/account/AccountPage';
import CancellationPage from './pages/payment/CancellationPage';
import TermsPage from './pages/signup/TermsPage';
import CookieBanner from './components/CookieBanner';

// Load Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

@inject('routerStore')
@observer
class App extends Component {
  render() {
    return (
      <Elements stripe={stripePromise}>
      <Fragment>
        <Route exact path="/" component={SignInPage} />
        <Route path="/signin/" component={SignInPage} />
        <Route path="/signup/" component={SignUpPage} />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/notes" component={NotesPage} />
        <Route exact path="/notes/create" component={CreateNotePage} />
        <Route exact path="/notes/update" component={UpdateNotePage} />
        <Route exact path='/account' component={AccountPage} />
        <Route exact path="/payment" component={PaymentPage} />
        <Route exact path="/cancellation" component={CancellationPage} />
        <CookieBanner />
      </Fragment>
      </Elements>
    );
  }
}

export default App;
